var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCameraSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H15C16.1046 18 17 17.1046 17 16V14.618L19.5528 15.8944C19.8628 16.0494 20.2309 16.0329 20.5257 15.8507C20.8205 15.6684 21 15.3466 21 15V9C21 8.65342 20.8205 8.33156 20.5257 8.14935C20.2309 7.96714 19.8628 7.95058 19.5528 8.10557L17 9.38197V8C17 6.89543 16.1046 6 15 6H5Z",
    fill: "#4A7628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraSolid);
export default __webpack_public_path__ + "static/media/video-camera-solid.de174fa8b66bba43129136ca1b164ac6.svg";
export { ForwardRef as ReactComponent };